import { boot } from 'quasar/wrappers';
import { RegisterHandsontable } from 'SharedDir/service/fields/handsontable';
import { RegisterClientComponent } from 'SharedDir/common/client-component';

export default boot(async ({ app }) => {
  RegisterHandsontable(app);
  RegisterClientComponent(app);
});
